(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["snippet-cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    const panel = drawer.querySelector('.cart-drawer__panel');
    let lastFocus = null;
    const open = (e) => {
      if (e) e.preventDefault();
      lastFocus = document.activeElement;
      drawer.hidden = false;
      drawer.querySelector('.cart-drawer__close')?.focus();
      document.addEventListener('keydown', onKey);
    };
    const close = () => {
      drawer.hidden = true;
      document.removeEventListener('keydown', onKey);
      lastFocus?.focus();
    };
    const onKey = (e) => {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        const f = panel.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };
    document.querySelectorAll('[data-cart-open]').forEach((b) => b.addEventListener('click', open));
    drawer.querySelectorAll('[data-cart-close]').forEach((b) => b.addEventListener('click', close));
  })();
  } catch(e) { console.error(e); }
})();

})();
